<template>
  <div class="invoice-manage-wrap">
    <!-- 标题 -->
    <div class="page-title">{{title}}</div>
    <!-- tab切换 -->
    <pageTab :paramsLabel="'type'" :isParams="true" :nowTab="routeType" :tabs="tab"></pageTab>
    <div ref="invoiceTips" class="invoice-tips" :class="{'invoice-tips-none': invoiceTipsNone}" :style="{'height': invoiceTipsHeight + 'px'}">
      <div class="invoice-tips-text">
        <p>自2020年10月1日起，开具发票需要从线上申请，平台开具发票以用户申请记录为准。</p>
      </div>
      <i class="iconfont iconshanchu1 yjh-active" @click.stop="closeInvoiceTips"></i>
    </div>
    <!-- 搜索 -->
    <page-search :layout="searchLayout" @search="search" @exportTable="exportTable"></page-search>
    <!-- 表格 -->
    <pageTable
      ref="pageTable"
      :loading="tableLoading"
      :col="innerCol"
      :data="tableData"
      :total="total"
      :pageIndex="page"
      :pageSize="pageSize"
      hoverColor="#EDF5FC"
      @compFn="customCompFunc"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>
<script>
import bus from '@/components/eventBus.js'
import { downFile } from '@/utils/file'
import pageTab from '@/components/pageCom/pageTab'
import pageSearch from '@/components/pageCom/pageSearch'
import pageTable from '@/components/pageCom/pageTable'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import invoiceTableMixin from './components/invoiceTableMixin.js'
import { getInvoiceListBj, getInvoiceRecordListBj, getZfjl, getInvoiceListGy, getInvoiceRecordListGy, getZfjlGy } from '@/api/invoiceManage.js'
export default {
  name: 'invoiceManage',
  components: {
    pageTab, pageSearch,
    pageTable
  },
  mixins: [pageTableMixin, invoiceTableMixin],
  data() {
    return {
      // 提示条内容
      invoiceTipsHeight: 38, // 提示信息框高度
      invoiceTipsNone: false,
      tabBj: [ // tab标签
        {
          linkName: '1',
          text: '交易结算',
          num: '0'
        },
        {
          linkName: '2',
          text: '直播会议',
          num: '0'
        },
        {
          linkName: '3',
          text: '会员服务',
          num: '0'
        }
      ],
      tabGy: [ // tab标签
        {
          linkName: '1',
          text: '信息调研',
          num: '0'
        }
      ],
      titleList: [{ // 名称集合
        name: 'invoiceApplyBj', label: '开票申请'
      }, {
        name: 'invoiceRecordBj', label: '开票记录'
      }, {
        name: 'invoiceDiscardBj', label: '作废记录'
      }, { // 名称集合
        name: 'invoiceApplyGy', label: '开票申请'
      }, {
        name: 'invoiceRecordGy', label: '开票记录'
      }, {
        name: 'invoiceDiscardGy', label: '作废记录'
      }],
      searchLayout: ['invoiceStatus', 'invoiceCode', 'invoiceTitle', 'invoiceDate', 'export', 't_agent_info_agent_name'], // 筛选项集合
      formData: {
        invoice_status: '',
        invoice_no: '',
        invoice_title: '',
        apply_time_start: '',
        apply_time_end: '',
        t_agent_info_agent_name: ''
      }
    }
  },
  computed: {
    tab() {
      if (this.$route.name.includes('Bj')) {
        return this.tabBj
      } else {
        return this.tabGy
      }
    },
    routeType() {
      return this.$route.params.type
    },
    routeName() {
      return this.$route.name
    },
    // 页面标题
    title() {
      const title = this.titleList.filter(item => item.name === this.routeName)
      return title[0].label
    },
    innerCol() {
      const name = this.routeName
      if (name.includes('Gy')) {
        return this.col[name.replace('Gy', 'Bj')]
      } else {
        return this.col[this.routeName]
      }
    }
  },
  watch: {
    routeName() {
      if (this.routeName.includes('invoiceDiscard')) {
        this.searchLayout = ['invoiceCode', 'invoiceTitle', 'invoiceDate', 'export', 't_agent_info_agent_name'] // 筛选项集合
      } else {
        this.searchLayout = ['invoiceStatus', 'invoiceCode', 'invoiceTitle', 'invoiceDate', 'export', 't_agent_info_agent_name'] // 筛选项集合
      }
    },
    '$route'() {
      bus.$emit('changeMenu')
    }
  },
  mounted() {
    // 获取列表数据
    if (this.routeName.includes('invoiceDiscard')) {
      this.searchLayout = ['invoiceCode', 'invoiceTitle', 'invoiceDate', 'export', 't_agent_info_agent_name'] // 筛选项集合
    } else {
      this.searchLayout = ['invoiceStatus', 'invoiceCode', 'invoiceTitle', 'invoiceDate', 'export', 't_agent_info_agent_name'] // 筛选项集合
    }
  },
  methods: {
    initPage() {
      this.formData = {
        invoice_status: '',
        invoice_no: '',
        invoice_title: '',
        apply_time_start: '',
        apply_time_end: '',
        t_agent_info_agent_name: ''
      }
    },
    // 搜索
    search(val) {
      // invoiceCode: ""
      // invoiceDate: (2) ["", ""]
      // invoiceStatus: "0"
      // invoiceTitle: ""
      this.formData = {
        invoice_status: val.invoiceStatus === '-1' ? '' : val.invoiceStatus,
        invoice_no: val.invoiceCode,
        invoice_title: val.invoiceTitle,
        apply_time_start: val.invoiceDate[0],
        apply_time_end: val.invoiceDate[1],
        t_agent_info_agent_name: val.t_agent_info_agent_name || ''
      }
      this.getData() // 搜索
    },
    // 获取列表
    getData() {
      this.tableLoading = true
      const params = {
        current_page: this.page,
        rp: this.pageSize,
        invoice_status: this.formData.invoice_status, // 发票状态
        invoice_no: this.formData.invoice_no, // 申请编码
        invoice_title: this.formData.invoice_title, // 发票抬头
        apply_time_start: this.formData.apply_time_start, // 申请时间-开始
        apply_time_end: this.formData.apply_time_end, // 申请时间-结束
        t_agent_info_agent_name: this.formData.t_agent_info_agent_name // 渠道
      }
      if (this.routeName === 'invoiceApplyBj') {
        // 开票申请-北京
        getInvoiceListBj(params, this.routeType).then(res => {
          this.setTablePublic(res)
        })
      } else if (this.routeName === 'invoiceRecordBj') {
        // 开票记录-北京
        getInvoiceRecordListBj(params, this.routeType).then(res => {
          this.setTablePublic(res)
        })
      } else if (this.routeName === 'invoiceDiscardBj') {
        // 作废记录-北京
        getZfjl(params, this.routeType).then(res => {
          this.setTablePublic(res)
        })
      } else if (this.routeName === 'invoiceApplyGy') {
        // 开票申请-贵阳
        getInvoiceListGy(params).then(res => {
          this.setTablePublic(res)
        })
      } else if (this.routeName === 'invoiceRecordGy') {
        // 开票记录-贵阳
        getInvoiceRecordListGy(params).then(res => {
          this.setTablePublic(res)
        })
      } else if (this.routeName === 'invoiceDiscardGy') {
        // 作废记录-贵阳
        getZfjlGy(params).then(res => {
          this.setTablePublic(res)
        })
      }
    },
    // 设置表格数据公共函数
    setTablePublic(res) {
      const { code, result } = res
      if (code === 0) {
        this.tableData = result.data
        // tab-总数
        if (this.routeName.includes('Bj')) {
          this.tabBj[0].num = result.total_data.jiaoyi_jiesuan !== undefined ? result.total_data.jiaoyi_jiesuan : result.total
          this.tabBj[1].num = result.total_data.zhibo_count !== undefined ? result.total_data.zhibo_count : result.total
          this.tabBj[2].num = result.total_data.hy_count !== undefined ? result.total_data.hy_count : result.total
        } else {
          this.tabGy[0].num = result.total
        }
      }
      this.tableLoading = false
    },
    // 表格组件触发事件
    customCompFunc(params) {
      this.$router.push({
        name: 'invoiceDetailPage',
        params: {
          changeType: this.routeName,
          operate: params.operate, // operate: 1-审核，2-填写物流信息
          type: this.routeType, // 当前类型，1:交易，2:直播，3:会员
          id: params.invoice_no, // 申请编号
          invoiceType: params.invoiceType
        }
      })
    },
    // 导出
    exportTable() {
      // 4开票申请-交易结算；   5开票申请-交易结算—账单明细；
      // 6开票申请-直播会议；   7开票申请-直播会议-账单明细
      // 8开票申请-会员；       9开票申请-会员-账单明细
      // 12开票记录-交易结算；  13开票记录-直播会议；14开票记录-会员服务；
      // 10信息调研-开票申请；  11调研-账单明细；
      // 15开票记录-信息调研；16作废记录-信息调研
      const exportType = {
        invoiceApplyBj: ['', '4', '6', '8'], // 开票申请-北京
        invoiceRecordBj: ['', '12', '13', '14'], // 开票记录-北京
        invoiceDiscardBj: ['', '16', '17', '18'], // 作废记录-北京
        invoiceApplyGy: ['', '10'], // 开票申请-贵阳
        invoiceRecordGy: ['', '15'], // 开票记录-贵阳
        invoiceDiscardGy: ['', '19'] // 作废记录-贵阳
        // invoiceGy: ['', '10', '15', '16']
      }
      const url = process.env.VUE_APP_BASE_API + '/invoice/export_excel'
      const params = {
        table_type: exportType[this.routeName][this.routeType],
        current_page: this.page,
        rp: this.pageSize,
        invoice_status: this.formData.invoice_status, // 发票状态
        invoice_no: this.formData.invoice_no, // 申请编码
        invoice_title: this.formData.invoice_title, // 发票抬头
        apply_time_start: this.formData.apply_time_start, // 申请时间-开始
        apply_time_end: this.formData.apply_time_end, // 申请时间-结束
        t_agent_info_agent_name: this.formData.t_agent_info_agent_name // 渠道
      }
      downFile(url, params)
    },
    // 关闭tips
    closeInvoiceTips() {
      const _this = this
      _this.invoiceTipsHeight = 0
      setTimeout(() => {
        _this.invoiceTipsNone = true
        _this.$refs.pageTable.resize()
      }, 150)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.invoice-tips {
  position: relative;
  width: 100%;
  height: 38px;
  border: solid 1px $blue;
  background: rgba(51, 133, 242, 0.1);
  border-radius: 2px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0 10px;
  transition: all .2s;
  overflow: hidden;
  p {
    width: 100%;
    padding: 0;
    margin: 0;
    font-size: 12px;
    color: $black;
    line-height: 38px;
  }
  & .iconshanchu1 {
    position: absolute;
    display: inline-block;
    top: 11px;
    right: 10px;
    font-size: 16px;
    color: $lineColor;
    width: 16px;
    // height: 16px;
  }
}
.invoice-tips-none {
  display: none;
}
</style>
